import React from "react";
import "./css/adjustable_interest_rate_table.css";
import PercentField from "../../fields/percent_field";
import NumberField from "../../fields/number_field";
import Decimal from "decimal.js";
import {
  buydown_year_rate,
  buydown_full_rate_year,
  buydown_first_change_month,
  buydown_first_rate_step,
  buydown_subsequent_rate_step,
  buydown_reductions
} from "../../../calculations/buydown";

// Step Rate ("Rate Option") disclosure — the rate steps up each year until it
// reaches the note rate. Mirrors the ARM AIR table layout.
export default function BuydownAirTable({ loan }) {
  const firstYearRate = buydown_year_rate(loan, 1);
  const noteRate = new Decimal(loan.rate || "0");
  const lifeCap = buydown_reductions(loan)[0] || 0;

  return (
    <table className="adjustable-interest-rate-table">
      <colgroup>
        <col />
        <col />
        <col />
      </colgroup>
      <tbody>
        <tr>
          <td className="big-font" colSpan="3">
            Adjustable Interest Rate (AIR) Table
          </td>
        </tr>
        <tr>
          <td colSpan="2">Initial Interest Rate</td>
          <td className="right-align">
            <PercentField naked decimalPlaces={3} value={firstYearRate} />
          </td>
        </tr>
        <tr>
          <td>Minimum/Maximum Interest Rate</td>
          <td className="center-align">
            <PercentField naked decimalPlaces={3} value={firstYearRate} />
          </td>
          <td className="right-align">
            <PercentField naked decimalPlaces={3} value={noteRate} />
          </td>
        </tr>
        <tr>
          <td className="bold" colSpan="3">
            Change Frequency
          </td>
        </tr>
        <tr>
          <td>First Change</td>
          <td className="right-align" colSpan="2">
            Beginning of month{" "}
            <NumberField naked value={buydown_first_change_month(loan)} />
          </td>
        </tr>
        <tr>
          <td>Subsequent Changes</td>
          <td className="right-align" colSpan="2">
            Every 12th month after first change until year{" "}
            <NumberField naked value={buydown_full_rate_year(loan)} />
          </td>
        </tr>
        <tr>
          <td className="bold" colSpan="3">
            Limits on Interest Rate Changes
          </td>
        </tr>
        <tr>
          <td>First Change</td>
          <td className="right-align" colSpan="2">
            <PercentField
              naked
              fixedDigits={0}
              value={buydown_first_rate_step(loan)}
            />
          </td>
        </tr>
        <tr>
          <td>Subsequent Changes</td>
          <td className="right-align" colSpan="2">
            <PercentField
              naked
              fixedDigits={0}
              value={buydown_subsequent_rate_step(loan)}
            />
          </td>
        </tr>
        <tr>
          <td>Life Maximum Interest Rate Cap</td>
          <td className="right-align" colSpan="2">
            <PercentField naked fixedDigits={0} value={lifeCap} />
          </td>
        </tr>
      </tbody>
    </table>
  );
}
